export const DEFAULT_INITIAL_SCALE = 1;
